'use client'

import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import React from "react";
import LoaderOverlay from "@/components/common/LoaderOverlay";
import Button_Fund from "@/components/funding/common/Button_Fund";
import dynamic from "next/dynamic";
import Spinner_Fund from "@/components/funding/common/Spinner_Fund";
import '@/components/styles/funding/SecOnboard.scss';
import { useFunding } from "@/context/funding";

const FeatureCard_Fund = dynamic(() => import("@/components/funding/common/FeatureCard_Fund"), {
    ssr: false,
});

const SecModalForm = dynamic(() => import("@/components/funding/SecModalForm"), {
    ssr: false,
});

export default function Page() {
    const t = useTranslations('funding');
    const route = useRouter();
    const { fundingStatus, GetFundingStatus, statusLoading, isRetryingStatus } = useFunding();
    const [isNavigating, setIsNavigating] = React.useState(false);

    const features = [
        {
            icon: '/assets/funding/icon-ai-portrait0.svg',
            title: t('landing.feature_1_title'),
            description: t('landing.feature_1_description'),
            className: 'head2',
            iconClassName: 'icon-ai-portrait',
            dataNumContainer: 333,
            dataNumIcon: 334,
            dataNumTitle: 335,
            dataNumDesc: 336
        },
        {
            icon: '/assets/funding/icon-type-prompt0.svg',
            title: t('landing.feature_2_title'),
            description: t('landing.feature_2_description'),
            className: 'head3',
            iconClassName: 'icon-type-prompt',
            dataNumContainer: 337,
            dataNumIcon: 338,
            dataNumTitle: 339,
            dataNumDesc: 340
        },
        {
            icon: '/assets/funding/icon-regenerate-b0.svg',
            title: t('landing.feature_3_title'),
            description: t('landing.feature_3_description'),
            className: 'head3',
            iconClassName: 'icon-regenerate-b',
            dataNumContainer: 341,
            dataNumIcon: 342,
            dataNumTitle: 343,
            dataNumDesc: 344
        }
    ];

    React.useEffect(() => {
        GetFundingStatus();
    }, []);

    React.useEffect(() => {
        if (fundingStatus) {
            if (!fundingStatus.need_onboarding) {
                route.push('/funding/templates');
            }
        }
    }, [fundingStatus, route]);













    return <div className="SecOnboard box" data-num="325">

        <LoaderOverlay visible={statusLoading} />

        {statusLoading && (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px',
                flexDirection: 'column'
            }}>
                <Spinner_Fund />
                <p style={{ marginTop: '1rem', color: '#666' }}>
                    {'Loading...'}
                </p>
                {isRetryingStatus && (
                    <p style={{ marginTop: '0.5rem', color: '#888', fontSize: '0.9rem' }}>
                        {'Retrying funding status in 10 seconds...'}
                    </p>
                )}
            </div>
        )}
        {
            !statusLoading && fundingStatus && (fundingStatus.need_onboarding) && <>
                    <div className="head" data-num="326">
                        <div className="title" data-num="327">
                            <div className="your-academic-funding-journey-starts-here" data-num="328">
                                {t('landing.onboarding_title')}
                            </div>
                            <div className="find-and-secure-your-fully-funded-m-sc-ph-d-or-postdoc-position-faster-smarter-easier" data-num="329">
                                {t('landing.subtitle')}
                            </div>
                        </div>
                    <img className="pic" src="/assets/funding/pic0.png" data-num="330" />
                </div>
                <div className="frame-427319733" data-num="331">
                    <div className="frame-427319730" data-num="332">
                        {features.map((feature, index) => (
                            <FeatureCard_Fund {...feature} key={index} />
                        ))}
                    </div>
                    <div className="frame-427319732" data-num="345">
                        <div className="head4" data-num="346">
                            <img className="icon-generate-b" src="/assets/funding/icon-generate-b0.svg" data-num="347" />
                            <div className="match-with-professors-actively-seeking-candidates-like-you2" data-num="348">
                                {t('landing.trial_title')}
                            </div>
                            <div className="our-ai-scans-research-projects-and-professor-profiles-in-canada-to-connect-you-with-the-most-relevant-professor-in-your-field2" data-num="349">
                                {t('landing.trial_description')}
                            </div>
                        </div>
                    </div>
                    <div className="frame-427319735" data-num="350">
                        <div className="frame-427319734" data-num="351">
                            <Button_Fund
                                className="button"
                                data-num="352"
                                onClick={() => {
                                    setIsNavigating(true);
                                    route.push('/packages');
                                }}
                                disabled={isNavigating}
                            >
                                <div className="base" data-num="353">
                                    <div className="button2" data-num="354">
                                        {isNavigating ? <Spinner_Fund /> : t('landing.buy_button')}
                                    </div>
                                </div>
                            </Button_Fund>
                            <Button_Fund
                                className="button3"
                                data-num="355"
                                onClick={() => {
                                    setIsNavigating(true);
                                    route.push('/funding/templates');
                                }}
                                disabled={isNavigating}
                            >
                                <div className="base" data-num="356">
                                    <div className="button4" data-num="357">
                                        {isNavigating ? <Spinner_Fund /> : t('landing.trial_button')}
                                    </div>
                                </div>
                            </Button_Fund>
                        </div>
                    </div>
                </div>
            </>
        }

    </div>
}
